import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetAgentsList = () => {
  const select = useCallback((data) => {
    return data?.data?.data;
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/agent/list",
    },

    {
      queryKey: ["agent-list"],
      select,
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );

  return response;
};
